var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc20Star = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "m9.555 15.983-3.463 1.902a.937.937 0 0 1-1.292-.42 1.04 1.04 0 0 1-.096-.634l.661-4.03a1.028 1.028 0 0 0-.275-.884L2.29 9.063a1.032 1.032 0 0 1-.017-1.413.943.943 0 0 1 .547-.292L6.69 6.77a.96.96 0 0 0 .72-.547l1.732-3.665c.234-.496.808-.699 1.281-.455a.98.98 0 0 1 .435.455l1.731 3.665c.14.295.409.5.72.547l3.872.588c.523.08.885.587.809 1.133-.03.218-.128.419-.28.572l-2.8 2.854c-.226.23-.329.56-.275.885l.66 4.029c.09.544-.26 1.061-.78 1.154a.92.92 0 0 1-.607-.1l-3.463-1.902a.92.92 0 0 0-.89 0Z",
  clipRule: "evenodd"
})));
export default SvgIc20Star;